import { styled } from '@mui/system'
import { MAX_GRADIENT_WIDTH, colors } from '../../consts'

export const PageHeaderCon = styled('div')(({ theme }) => ({
  maxWidth: '100vw',
  '& .bannerImg': {
    width: '100%',
  },
  '& .gradient': {
    position: 'absolute',
    left: 0,
    top: 0,
    bottom: 0,
    width: '100%',
    maxWidth: MAX_GRADIENT_WIDTH,
    background: 'linear-gradient(90deg, rgba(0,0,0,0.9) 0%, rgba(0,0,0,0) 100%)',
  },
}))

export const TextCon = styled('div')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  color: colors.white,
  padding: theme.spacing(4),
  fontWeight: 'bold',
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(2),
  },
  '& .title': {
    fontSize: 58,
    textTransform: 'uppercase',
    [theme.breakpoints.down('sm')]: {
      fontSize: 46,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 36,
    },
  },
  '& .description': {
    fontSize: 18,
    [theme.breakpoints.down('sm')]: {
      fontSize: 16,
    },
    [theme.breakpoints.down('xs')]: {
      fontSize: 14,
    },
  },
}))
